import API from "./api";
import { ShowProposalSubmitting } from "./snackbar";

const Harms = () => window.map_data.Harms.map(harm => harm.Term);
const ResourceTypes = () => window.map_data["Resource Types"].map(rt => rt.Term);
// OpenDialog removed - unused
import OpenErrorDialog from "./dialog_error";

export default class extends HTMLElement {
    fieldMappings = {
        "Title": { api_key: "new_title" },
        "Authors": { api_key: "authors" },
        "Publication": { api_key: "publication" },
        "External link": { api_key: "url", type: "link" },
        "Resource Type": { api_key: "resource_type", fn: this.resourceTypesSelectControlMarkup },
    }

    #originalTitle = ""

    connectedCallback () {
        this.#originalTitle = this.attributes.original_title.value;

        if (API.isLoggedIn) {
            this.innerHTML += `
                 <button id="propose-changes">Propose changes</button>
                <div class="edit-form">
                    <input type="text" id="reasoning" api-key="reasoning" placeholder="Describe your reasoning. Why is this change necessary?"></input>
                </div>
                <div class="edit-form buttons">
                    <button id="revert">Cancel</button>
                    <button id="save">Propose</button>
                </div>
                <p class="thanks"> </p>
                <p class="thanks">
                    Thank you for your proposal!
                </p>
            `;

            this.setAttribute("edit-mode", "none");

            const proposeButton = this.querySelector("button#propose-changes");
            proposeButton.addEventListener("click", async () => {
                this.setAttribute("edit-mode", "editing");
                this.prepareEditForm();
            });

            const revertButton = this.querySelector("button#revert");
            revertButton.addEventListener("click", async () => {
                this.setAttribute("edit-mode", "none");
                this.revertEditForm();
            });

            const saveButton = this.querySelector("button#save");
            saveButton.addEventListener("click", async () => {
                this.submitForm();
                this.setAttribute("edit-mode", "complete");
            });
        }
    }

    prepareEditForm () {
        const fields = this.querySelectorAll(".harm__related_resources__dialog__item");
        fields.forEach(field => {
            const dt = field.querySelector("dt");
            const dd = field.querySelector("dd");
            const mapping = this.fieldMappings[dt.innerHTML];

            if (!dt || !dd || !mapping) {
                return;
            }

            dd.setAttribute("api-key", mapping.api_key);
            dd.setAttribute("mapping-key", dt.innerHTML);

            if (mapping.fn) {
                dd.innerHTML = mapping.fn(dd.innerHTML);
                return;
            }

            dd.innerHTML = `<input type="text" api-key="${mapping.api_key}" value="${this.getDdMappedValue(dd, mapping)}"></input>`;
        });

        this.appendHarmSelect();
    }

    appendHarmSelect () {
        const harmsField = this.querySelector("[role='harms-display']");
        const harmsFieldDd = harmsField.querySelector("dd");

        const selectList = document.createElement("select");
        selectList.role = "new-harm-relation";

        const option = document.createElement("option");
        option.value = "";
        option.text = "New harm relation";
        selectList.appendChild(option);

        Harms().forEach(harm => {
            const option = document.createElement("option");
            option.value = harm;
            option.text = harm;
            selectList.appendChild(option);
        });

        harmsFieldDd.appendChild(selectList);
    }

    resourceTypesSelectControlMarkup (value) {
        const selectList = document.createElement("select");
        selectList.role = "rt-relation";
        selectList.name = "resource_type";
        selectList.id = "resource_type";
        selectList.setAttribute("api-key", "resource_type");
        selectList.setAttribute("original-value", value);

        ResourceTypes().forEach(rt => {
            const option = document.createElement("option");
            option.value = rt;
            option.text = rt;

            if (rt === value) {
                option.setAttribute("selected", "");
            }

            selectList.appendChild(option);
        });

        return selectList.outerHTML;
    }

    revertEditForm () {
        const fields = this.querySelectorAll("dd[api-key]");
        fields.forEach(dd => {
            const input = dd.querySelector("input, select");

            if (input.hasAttribute("original-value")) {
                dd.innerHTML = input.getAttribute("original-value");
                return;
            }

            const mapping = this.fieldMappings[dd.attributes["mapping-key"].value];
            dd.innerHTML = this.getDdUnpappedValue(input.value, mapping);
        });

        this.querySelectorAll("[role=new-harm-relation]").forEach(e => e.remove());

        const rt = this.querySelector("select#resource_type");
        if (rt) {
            rt.remove();
        }
    }

    async submitForm () {
        const values = {
            old_title: this.#originalTitle,
            additional_harms: Array.from(
                this.querySelectorAll("[role=new-harm-relation]")
            ).filter(
                ({ value }) => !!value
            ).map(
                ({ value }) => value
            ),
        };

        this.querySelectorAll("input[api-key],select[api-key]").forEach(field => {
            values[field.attributes["api-key"].value] = field.value;
        });

        this.revertEditForm();

        ShowProposalSubmitting();

        const response = await API.proposeResourceChange(values);
        if (response.status === 400) {
            const errorData = await response.json();
            OpenErrorDialog(errorData);
            return;
        }
    }

    getDdMappedValue (dd, mapping) {
        if (mapping.type === "link") {
            const a = dd.querySelector("a");
            return a.attributes.href.value;
        }

        if (dd.querySelector("span.none_value")) {
            return "";
        }

        return dd.innerHTML;
    }

    getDdUnpappedValue (value, mapping) {
        if (mapping.type === "link") {
            return `<a href=${value}>${value}</a>`;
        }
        return value;
    }


}
